/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import * as THREE from "three";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";
import model from "./Hotel_V13b.glb";
import bg from "./materials/Chicago_Downtown_Panorama.jpg";

export default function Model(props) {
  const group = useRef();
  const bgTexture = useTexture(bg);
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);
  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Espelho002"
          geometry={nodes.Espelho002.geometry}
          material={materials.Espelho}
          position={[1.73, 1.55, -0.71]}
        />
        <mesh
          name="Cadeira001"
          geometry={nodes.Cadeira001.geometry}
          material={materials.Cadeira}
          position={[-3.91, 0.48, 2.5]}
          rotation={[0, -1.57, 0]}
        />
        <mesh
          name="PortasCard001"
          geometry={nodes.PortasCard001.geometry}
          material={materials.PortasCard}
          position={[0.21, 1.03, -2.79]}
        />
        <mesh
          name="Bancada002"
          geometry={nodes.Bancada002.geometry}
          material={materials.Bancada}
          position={[-2.38, 0.49, 2.95]}
        />
        <mesh
          name="CortinasApoio001"
          geometry={nodes.CortinasApoio001.geometry}
          material={materials.CortinasApoio}
          position={[-4.46, 1.46, 1.27]}
          rotation={[0, Math.PI / 2, 0]}
          scale={0.03}
        />
        <mesh
          name="Background002"
          geometry={nodes.Background002.geometry}
          material={materials.Background}
          material-emissive={new THREE.Color("#777777")}
          material-emissiveMap={bgTexture}
          material-emissiveMap-flipY={false}
          // material-map-flipY={false}
          position={[0, 2.0, 0]}
          rotation={[0, 1.02, 0]}
          scale={[4.85, 6.05, 4.85]}
        />
        <mesh
          name="RoupaCama001"
          geometry={nodes.RoupaCama001.geometry}
          material={materials.RoupaCama}
          position={[-2.41, 0.43, 0.94]}
        />
        <mesh
          name="Poltrona01001"
          geometry={nodes.Poltrona01001.geometry}
          material={materials.Poltrona01}
          position={[0.27, 0.4, 2.53]}
        />
        <mesh
          name="QuadrosArandelas002"
          geometry={nodes.QuadrosArandelas002.geometry}
          material={materials.QuadrosArandelas}
          position={[-2.4, 1.71, -0.7]}
        />
        <mesh
          name="Piso002"
          geometry={nodes.Piso002.geometry}
          material={materials.Piso}
          position={[0, 0, 0.43]}
        />
        <mesh
          name="Parede002"
          geometry={nodes.Parede002.geometry}
          material={materials.Parede}
          position={[-0.82, 1.45, 0.64]}
        />
        <mesh
          name="Forro002"
          geometry={nodes.Forro002.geometry}
          material={materials.Forro}
          position={[-0.31, 2.43, 0.08]}
          scale={0.17}
        />
        <mesh
          name="DivTV001"
          geometry={nodes.DivTV001.geometry}
          material={materials.DivTV}
          position={[0.82, 1.25, 1.06]}
        />
        <mesh
          name="Vidro001"
          geometry={nodes.Vidro001.geometry}
          material={materials.Vidro}
          material-depthWrite={false}
          position={[0.82, 1.25, 1.06]}
          rotation={[0, 0, -Math.PI / 2]}
        />
        <mesh
          name="ArmarioToalha001"
          geometry={nodes.ArmarioToalha001.geometry}
          material={materials.ArmarioToalha}
          position={[-0.39, 1.67, -1.86]}
        />
        <mesh
          name="MovelBanheiro001"
          geometry={nodes.MovelBanheiro001.geometry}
          material={materials.MovelBanheiro}
          position={[1.73, 0.86, -0.44]}
        />
        <mesh
          name="Poltrona02001"
          geometry={nodes.Poltrona02001.geometry}
          material={materials.Poltrona02}
          position={[-0.79, 0.4, 2.45]}
          rotation={[0, 0.34, 0]}
        />
        <mesh
          name="Banheira001"
          geometry={nodes.Banheira001.geometry}
          material={materials.Banheira}
          position={[2.01, 0.4, 1.5]}
        />
        <mesh
          name="Cama001"
          geometry={nodes.Cama001.geometry}
          material={materials.Cama}
          position={[-1.42, 0.2, 0.61]}
        />
        <mesh
          name="VidroLeitosoArandelas001"
          geometry={nodes.VidroLeitosoArandelas001.geometry}
          material={materials["Vidro Leitoso"]}
          position={[-2.41, 0.92, -0.58]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
